(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define("Main", [
      'jquery',
      'ofi',
      'menu',
      'request',
      'loadMore',
      'w5modules',
      'banner.js',
      'promotion'
    ], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory(
      require('jquery'),
      require('ofi'),
      require('menu'),
      require('request'),
      require('loadMore'),
      require('w5modules'),
      require('banner.js'),
      require("promotion")
    );
  } else {
    // Browser globals (root is window)
    root.returnExports = factory(
      root.jquery,
      root.ofi,
      root.Menu,
      root.formRequest,
      root.loadMore,
      root.w5modules,
      root.banner,
      root.promotion
    );
  }
}(typeof self !== 'undefined' ? self : this, function ($, ofi, Menu, formRequest, loadMore, W5modules, banner, promotion) {


  /**
   * Trigger jqueryOn event to banner.js
   */
  window.$ = $;

  $(function () {

    /**
     * Competition logo behavior
    */
    function competition(){

        function isElementInView(element, fullyInView) {
            let pageTop = $(window).scrollTop();
            let pageBottom = pageTop + $(window).height();
            let elementTop = $(element).offset().top;
            let elementBottom = elementTop + $(element).height();

            if (fullyInView === true) {
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            } else {
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
            }
        };

        $(window).scroll(function(){
            let gdprInView = isElementInView($('.gdpr-menu'), false);

            if($(window).width() > 1400){
                if(gdprInView){
                    $('footer').removeClass('scroll');
                }else {
                    $('footer').addClass('scroll');
                }
            }
        });
    }

      if($(window).width() > 1023){
          competition();
      }

    $(document).trigger('jqueryOn');

    /**
     * Object-fit fix on Explorer and Edge browsers
     */
    ofi.default("img", { watchMQ: true });

    /**
     * Menu init
     */
    new Menu();

    let buttonHtml = $('#footerNewsletter').find('[type=submit]').html();

    $('#footerNewsletter').w5request({
      selector: '#footerNewsletter',
      beforeSend: function () {
        this.find('[type="submit"]').attr('disabled', 'disabled').addClass('active').html(function () {
          return $(this).data('loading-text')
        });
      },
      complete: function (response, request) {
        this.replaceWith(response.data.html);
      },
      success: function () {
        let message = document.createElement('p');
        message.classList.add('success');
        message.innerText = this.data('success-text');

        this.get(0).reset();
        this.find('input').removeAttr('value checked');
        this.find('p.error').remove();
        this.find('p.success').remove();
        this.find('.error').removeClass('error');
        this.find('[type="submit"]').removeClass('active').removeAttr('disabled').html(buttonHtml);

        this.find('div:first-of-type').before(message);
      }
    });

    let $specialEvent = $('.special-event');

    if ($specialEvent.length > 0) {
      $specialEvent.prependTo('body');
      $specialEvent = $('.special-event');

      $('#closeSpecialEvent').on('click', function () {
        $specialEvent.fadeOut(500, function () {
          $specialEvent.remove();
        })
      });
    }


    $(document).on('click', '.js-accord', function () {
      $('.js-accord').not(this).removeClass('is-opened');
      $('.js-accord .js-accord-drop').not($(this).find('.js-accord-drop')).slideUp();

      $(this).toggleClass('is-opened');
      $(this).find('.js-accord-drop').slideToggle(function() {
        let offsetTop = $(this).parents(".js-accord").offset().top;
        $("html, body").animate({scrollTop:  offsetTop+ "px"}, 500);
      });

    });

    $('[data-bg]').each(function () {
      var bg = $(this).data('bg').trim();

      if (bg.length > 0) {
        $(this).css('backgroundImage', "url(" + bg + ")");
      }
    });

    /* wrap figure text */
    if ($('.article').length) {
      var figures = $('.article').find('figure');
      $.each(figures, function () {
        var spanItem = $('<span />');
        var text = $(this).find('figcaption').text().trim();
        $(this).find('figcaption').empty();
        $(this).find('figcaption').append(spanItem);
        $(this).find('figcaption').find('span').text(text);
      });
    }

    /**
     * Render news|event item HTML
     *
     * @param item
     * @param type
     * @param elementClass
     * @returns {Element}
     */
    function getHTML(item, type, elementClass) {
      let link = document.createElement('a'),
        imgContainer = document.createElement('div'),
        img = document.createElement('img'),
        article = document.createElement('article'),
        title = document.createElement('h3'),
        lead = document.createElement('p'),
        date = document.createElement('span');

      link.href = item.url;
      link.classList = elementClass;

      img.src = item.indexImage;
      img.alt = item.title;

      lead.innerText = item.lead;

      title.innerText = item.title;

      if (type === "event") date.innerText = item.createDate;

      article.appendChild(title);
      article.appendChild(lead);

      imgContainer.appendChild(img);

      link.appendChild(imgContainer);
      link.appendChild(article);
      if (type === "event") link.appendChild(date);

      return link;
    }

    $(".news-container .more").loadMore({
      elementSelector: '.news-container .more',
      containerSelector: '.news-container__inner',
      dataKeys: {
        loadingText: 'text-loading',
        noMoreText: 'text-nomore'
      },
      renderHtml: function (itemData) {
        return getHTML(itemData, 'new', 'new-card');
      }
    });

    $(".js-more-events").loadMore({
      elementSelector: '.js-more-events',
      containerSelector: '.c-events__inner',
      dataKeys: {
        loadingText: 'text-loading',
        noMoreText: 'text-nomore'
      },
      renderHtml: function (itemData) {
        return getHTML(itemData, 'event', 'c-events__card');
      }
    });

    $(".js-more-news").loadMore({
      elementSelector: '.js-more-news',
      containerSelector: '.c-news__inner',
      dataKeys: {
        loadingText: 'text-loading',
        noMoreText: 'text-nomore'
      },
      renderHtml: function (itemData) {
        return getHTML(itemData, 'new', 'c-news__card');
      }
    });

    /* display on mobil all hidden items */
    $(".news-container .more").on('click', function () {
      $(".news-container").find('.new-card').show();
    });

    if ($('.article').length) {
      let tables = $('.article').find('table');

      $.each(tables, function () {
        $(this).wrap("<div class='table-responsive'></div>");
      });
    }


    /**
     * Promotion form
     */

    function switchNotEmptyClass($element) {
      let enable = $element.val() !== "";

      $element.toggleClass("not-empty", enable);

      if (enable) {
        $element.parents(".form-group").removeClass("error");
      }
    }

    if ($("body").hasClass("promotion")) {
      let selector = "#promotionForm input:not([type='checkbox'])",
        inputs = $(selector);

      inputs.each(function () {
        let $input = $(this);

        switchNotEmptyClass($input);
      });

      $(document).on("change", selector, function () {
        let $input = $(this);

        switchNotEmptyClass($input);
      });
    }

    $(document).on('change', 'input[type="checkbox"]', function () {
      if (this.checked) {
        $(this).parents('.error').removeClass('error');
      }
    });
  });

  if ($('.multi-menu').length) {
    let listItems = $('.multi-menu').find('p');

    $.each(listItems, function() {
      if ($(this).next('ul').length) {
        $(this).addClass("hasUl");
      }
    });

    listItems.on('click', function (e) {
        e.stopPropagation();
        let $this = $(this);
        if ($this.next('ul').length) {
          $this.toggleClass('is-active');
          $this.next('ul').slideToggle();
        }
    });
  }

}));



//////////////////
// WEBPACK FOOTER
// ./js/src/main.js
// module id = 2
// module chunks = 0 1 2 3 4